<template>
  <div class="working-group-page">
    <!-- <div class="wg-hero">
      <img :src="heroBannerImage" alt="Working Groups Hero Banner" class="wg-hero-banner-image" />
    </div> -->

    <div class="wg-grid">
      <div class="wg-card">
        <div class="card-header">
          <img :src="iconValveRheumatic" alt="Valve & Rheumatic Heart Disease Icon" />
          <h2 class="card-title">Valve & Rheumatic Heart Disease</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Renan Sukmawan, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inavalverhd.inaheart.org/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconInterventional" alt="Interventional Cardiology Icon" />
          <h2 class="card-title">Interventional Cardiology</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Dafsah Arifa Djalan, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://www.isic.or.id/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconElectrophysiology" alt="Electrophysiology & Pacing Icon" />
          <h2 class="card-title">Electrophysiology & Pacing</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Dicky Armein Hanafy, PhD, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Gedung Utama Lantai 2, Ruang Poliklinik,
            Jakarta
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> ina.hrs.perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inahrs.or.id/" target="blank" class="visit-website-btn">VISIT WEBSITE</a>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconPediatricCardiology" alt="Pediatric Cardiology Icon" />
          <h2 class="card-title">Pediatric Cardiology & Congenital Heart Disease</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Oktavia Lilyasari, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Gedung Pusat Jantung Nasional, Lt. 2, Jl.
            Letjend S. Parman No. 87, Jakarta Barat
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@yahoo.com</p>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconAcuteCardio" alt="Acute Cardiovascular Care Icon" />
          <h2 class="card-title">Acute Cardiovascular Care</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Antonia Anna Lukito, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inaacc.or.id/" target="blank" class="visit-website-btn">VISIT WEBSITE</a>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconVascularMedicine" alt="Vascular Medicine Icon" />
          <h2 class="card-title">Vascular Medicine</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Marisi Pardede, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://www.indovascular.org/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconEchocardiography" alt="Echocardiography Icon" />
          <h2 class="card-title">Echocardiography</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Siska Suridanda Danny, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> ina.echo@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://indonesianecho.org/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconHeartFailure" alt="Heart Failure Icon" />
          <h2 class="card-title">Heart Failure</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Isman Firdaus, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inahfcarmet.org/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconHypertension" alt="Hypertension Icon" />
          <h2 class="card-title">Hypertension</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Arieska Annisa, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> inashperki@gmail.com</p>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img
            :src="iconCardioPrevention"
            alt="Cardiovascular Prevention and Rehabilitation Icon"
          />
          <h2 class="card-title">Cardiovascular Prevention and Rehabilitation</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Jajang Jaya, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
        <div class="card-footer">
          <a href="https://inaprevent.org/" target="blank" class="visit-website-btn"
            >VISIT WEBSITE</a
          >
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconAtherosclerosis" alt="Atherosclerosis Icon" />
          <h2 class="card-title">Atherosclerosis, Thrombosis, Lipidology & Regenerative Therapy</h2>
        </div>
        <div class="card-body">
          <p class="card-detail"><strong>Chairman:</strong> Dr. Suko Adiarto, Sp.JP(K), FIHA</p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconWomanCardiology" alt="Woman Cardiology Icon" />
          <h2 class="card-title">Woman Cardiology</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Dede Moedeian Ambari, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Kota Bambu
            Utara, Jakarta – 11420
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perkiwomancardio@gmail.com</p>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconNuclearCardiology" alt="Nuclear Cardiology & Cardiac Imaging Icon" />
          <h2 class="card-title">Nuclear Cardiology & Cardiac Imaging</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Anna Ulfa Rahajoe, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Slipi,
            Jakarta Barat
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
      </div>

      <div class="wg-card">
        <div class="card-header">
          <img :src="iconPulmonaryHypertension" alt="Pulmonary Hypertension Icon" />
          <h2 class="card-title">Pulmonary Hypertension</h2>
        </div>
        <div class="card-body">
          <p class="card-detail">
            <strong>Chairman:</strong> Dr. Amiliana Mardiani Soesanto, Sp.JP(K), FIHA
          </p>
          <p class="card-detail">
            <strong>Address:</strong>
            RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Grogol,
            Jakarta Barat
          </p>
          <p class="card-detail"><strong>Contact Number:</strong> 021 568 1199</p>
          <p class="card-detail"><strong>Email:</strong> perki@gmail.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// --- TAMBAHAN: Import gambar banner hero Anda ---
// Pastikan path ini sesuai dengan lokasi file Anda
// import heroBannerImage from '@/assets/img/about-us/working-group/wg-hero-banner.png'

// --- IMPORT SEMUA ICON CARD (Tetap sama) ---
import iconValveRheumatic from '@/assets/img/about-us/working-group/ina-valve.png'
import iconInterventional from '@/assets/img/about-us/working-group/isic.png'
import iconElectrophysiology from '@/assets/img/about-us/working-group/ina-hrs.png'
import iconPediatricCardiology from '@/assets/img/about-us/working-group/wg-pcchd.png'
import iconAcuteCardio from '@/assets/img/about-us/working-group/wg-perki.png'
import iconVascularMedicine from '@/assets/img/about-us/working-group/indo-vascular.png'
import iconEchocardiography from '@/assets/img/about-us/working-group/ise.png'
import iconHeartFailure from '@/assets/img/about-us/working-group/ina-hf.png'
import iconHypertension from '@/assets/img/about-us/working-group/hypertention.png'
import iconCardioPrevention from '@/assets/img/about-us/working-group/cpr.png'
import iconAtherosclerosis from '@/assets/img/about-us/working-group/perki.png'
import iconWomanCardiology from '@/assets/img/about-us/working-group/woman-cardiology.png'
import iconNuclearCardiology from '@/assets/img/about-us/working-group/isci.png'
import iconPulmonaryHypertension from '@/assets/img/about-us/working-group/ina-ph.png'

export default {
  name: 'WorkingGroup',
  data() {
    return {
      // --- TAMBAHAN: Daftarkan gambar banner di data() ---
      // heroBannerImage,

      // --- DAFTAR ICON CARD (Tetap sama) ---
      iconValveRheumatic,
      iconInterventional,
      iconElectrophysiology,
      iconPediatricCardiology,
      iconAcuteCardio,
      iconVascularMedicine,
      iconEchocardiography,
      iconHeartFailure,
      iconHypertension,
      iconCardioPrevention,
      iconAtherosclerosis,
      iconWomanCardiology,
      iconNuclearCardiology,
      iconPulmonaryHypertension,
    }
  },
}
</script>

<style scoped>
.working-group-page {
  font-family: 'Arial', sans-serif;
  padding: 0;
  background-color: #ffffff;
}

/* --- DIUBAH: CSS untuk hero banner --- */
.wg-hero {
  width: 100%;
  margin-bottom: 3rem; /* Jarak dengan grid di bawahnya */
}

.wg-hero-banner-image {
  width: 100%;
  height: auto; /* Biarkan tinggi menyesuaikan agar gambar tidak terdistorsi */
  display: block; /* Menghilangkan spasi ekstra di bawah gambar */
  object-fit: cover; /* Memastikan gambar menutupi area, bisa diganti 'contain' jika perlu */
}

/* --- HAPUS: CSS untuk .wg-title dan .wg-description tidak diperlukan lagi --- */

.wg-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto 5rem auto;
  padding: 0 2rem;
}

.wg-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.wg-card:hover {
  transform: translateY(-5px);
}

.card-header {
  background-color: #ffffff;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.card-header img {
  /* width: 90px;
  height: 90px; */
  margin-bottom: 1rem;
  object-fit: contain;
}

.card-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #e10f28;
  text-align: center;
  margin: 0;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-body {
  padding: 1.5rem;
  flex-grow: 1;
  text-align: left;
}

.card-detail {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.card-detail strong {
  color: #333;
  display: block;
  margin-bottom: 0.25rem;
}

.card-footer {
  background-color: #f0f0f0;
  padding: 1.5rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.visit-website-btn {
  display: inline-block;
  background-color: #e10f28;
  color: #fff;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.visit-website-btn:hover {
  background-color: #d62828;
}

/* --- Media Queries (Tetap sama) --- */

@media (max-width: 1200px) {
  .wg-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .wg-hero {
    /* Hapus padding dari wg-hero lama jika ada */
    padding: 0;
    margin-bottom: 2rem; /* Kurangi margin di mobile */
  }

  .wg-grid {
    grid-template-columns: 1fr;
    padding: 0 1rem;
  }

  .card-title {
    min-height: auto;
  }
}
</style>
